import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-sm" }
const _hoisted_3 = { class: "font-bold text-xl" }
const _hoisted_4 = { class: "flex-1 py-2" }
const _hoisted_5 = { class: "block lg:hidden" }
const _hoisted_6 = { class: "hidden lg:block" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "|", -1)
const _hoisted_9 = { class: "" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "|", -1)
const _hoisted_11 = { class: "" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "|", -1)
const _hoisted_13 = { class: "font-bold" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "|", -1)
const _hoisted_15 = { class: "font-bold" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "flex justify-center border-t-2 pt-5" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Close")
const _hoisted_20 = { class: "flex flex-col items-center space-y-5" }
const _hoisted_21 = { class: "text-center text-2xl font-semibold" }
const _hoisted_22 = { class: "flex flex-row space-x-2 items-center" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, "NO", -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode()
const _hoisted_25 = { class: "flex flex-row space-x-2 items-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", null, "YES", -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_tag = _resolveComponent("n-tag")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_button_group = _resolveComponent("n-button-group")!
  const _component_ParticipantReplay = _resolveComponent("ParticipantReplay")!
  const _component_ParticipantList = _resolveComponent("ParticipantList")!
  const _component_ParticipantFinish = _resolveComponent("ParticipantFinish")!
  const _component_n_card = _resolveComponent("n-card")!
  const _component_IosInformationCircle = _resolveComponent("IosInformationCircle")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_MdCloseCircle = _resolveComponent("MdCloseCircle")!
  const _component_IosCheckmarkCircle = _resolveComponent("IosCheckmarkCircle")!
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_n_card, {
            title: "",
            bordered: false,
            size: "huge",
            role: "dialog",
            "aria-modal": "true",
            "content-style": _ctx.contentStyle,
            "header-style": _ctx.headerStyle
          }, {
            header: _withCtx(() => [
              (_ctx.eventType == _ctx.EventType.Paticipation)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["flex-wrap", { 'text-white': _ctx.event.Status == _ctx.ParamEventStatus.Open ,'text-infoColor': _ctx.event.Status == _ctx.ParamEventStatus.Close ,
                  'bg-infoColor': _ctx.event.Status == _ctx.ParamEventStatus.Open }])
                  }, [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.event?.Title), 1),
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createTextVNode(_toDisplayString(_ctx.displayText) + " ", 1),
                          _withDirectives(_createElementVNode("a", {
                            class: _normalizeClass(["px-2 py-1 text-xs rounded-sm hover:underline", { 'text-gray-50': _ctx.event.Status == _ctx.ParamEventStatus.Close ,'text-infoColor': _ctx.event.Status == _ctx.ParamEventStatus.Open ,
                  'bg-infoColor': _ctx.event.Status == _ctx.ParamEventStatus.Close, ' bg-gray-200': _ctx.event.Status == _ctx.ParamEventStatus.Open,
                  'hover:bg-gray-500':  _ctx.event.Status == _ctx.ParamEventStatus.Close,'hover:bg-gray-400':  _ctx.event.Status == _ctx.ParamEventStatus.Open}]),
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleReadMore && _ctx.toggleReadMore(...args))),
                            href: "#"
                          }, _toDisplayString(_ctx.isExpanded ? _ctx.t('ReadLess') : _ctx.t('ReadMore')), 3), [
                            [_vShow, _ctx.isReadMore]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.event?.Description), 1)
                      ]),
                      _createVNode(_component_n_tag, {
                        type: _ctx.typeColor(_ctx.event?.Status),
                        bordered: false,
                        size: "small",
                        color: { color: _ctx.headerStyle.type , textColor: '#fff' }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.statusHeaders.find(
              (u) =>
              u.Value == _ctx.event?.Status
              )?.Name), 1)
                        ]),
                        _: 1
                      }, 8, ["type", "color"]),
                      _createVNode(_component_n_space, { class: "pt-2" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.t('WatingReply')) + ": " + _toDisplayString(_ctx.event.HeadCount - _ctx.event.ResponseCount), 1),
                          _hoisted_8,
                          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.t('Deadline')) + ": " + _toDisplayString(_ctx.datetimeString(_ctx.event?.SubmitDueDateUTCDateTime ?? new Date().toISOString())), 1),
                          _hoisted_10,
                          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.t('Applicant')) + ": " + _toDisplayString(_ctx.event?.ApplierName), 1),
                          _hoisted_12,
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.t('ResponseRate')) + ": " + _toDisplayString(_ctx.percentage(_ctx.event?.ResponseCount ?? 0, _ctx.event?.HeadCount ?? 1)) + "%", 1),
                          _hoisted_14,
                          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.t('Attendee')) + ": " + _toDisplayString(_ctx.userRes.Member.Name), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_n_space, { class: "pt-2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_n_tag, {
                            type: "error",
                            bordered: false,
                            size: "small",
                            color: { color:'#FF3C38', textColor: '#fff' }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('AttendeeNotices')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              (_ctx.eventType == _ctx.EventType.Paticipation)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.event?.Status == _ctx.ParamEventStatus.Open)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_n_button_group, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_n_button, {
                                type: "info",
                                ghost: _ctx.tabType(0),
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedTab=0))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('ReplyMeeing')), 1)
                                ]),
                                _: 1
                              }, 8, ["ghost"]),
                              _createVNode(_component_n_button, {
                                type: "info",
                                ghost: _ctx.tabType(1),
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedTab=1))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('AttendeeList')), 1)
                                ]),
                                _: 1
                              }, 8, ["ghost"])
                            ]),
                            _: 1
                          }),
                          (_ctx.selectedTab==0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_ctx.event !== null)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createVNode(_component_ParticipantReplay, { event: _ctx.event }, null, 8, ["event"]),
                                      _hoisted_16
                                    ], 64))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_17, "There is no data."))
                              ], 64))
                            : (_ctx.selectedTab==1)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (_ctx.event !== null)
                                    ? (_openBlock(), _createBlock(_component_ParticipantList, {
                                        key: 0,
                                        event: _ctx.event
                                      }, null, 8, ["event"]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createBlock(_component_ParticipantFinish, {
                          key: 1,
                          event: _ctx.event,
                          class: "pb-5"
                        }, null, 8, ["event"]))
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_n_button, {
                  size: "large",
                  color: _ctx.themeVars.infoColor,
                  onClick: _ctx.onClose
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                }, 8, ["color", "onClick"])
              ])
            ]),
            _: 1
          }, 8, ["content-style", "header-style"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_n_modal, {
      show: _ctx.showConfirmModal,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showConfirmModal) = $event)),
      class: "custom-card",
      preset: "card",
      bordered: false,
      size: "huge",
      style: { width: '400px'},
      onClose: _ctx.onNegativeClick
    }, {
      header: _withCtx(() => []),
      footer: _withCtx(() => [
        _createVNode(_component_n_space, { justify: "center" }, {
          default: _withCtx(() => [
            _createVNode(_component_n_button, {
              size: "large",
              ghost: "",
              type: "success",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onNegativeClick()))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _hoisted_24,
                  _createVNode(_component_n_icon, { size: "28" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_MdCloseCircle)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_n_button, {
              size: "large",
              type: "success",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onPositiveClick()))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _hoisted_27,
                  _createVNode(_component_n_icon, { size: "28" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_IosCheckmarkCircle)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_n_icon, {
            size: "100",
            class: "text-warningColor"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IosInformationCircle)
            ]),
            _: 1
          }),
          _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.t('AlartContext') + _ctx.userRes.Member.Name + '?'), 1)
        ])
      ]),
      _: 1
    }, 8, ["show", "onClose"])
  ], 64))
}